import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { portalApi } from '../utils/portalApi';

export default function InsightsPage() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    portalApi.getPublicArticles().then((data) => setArticles(data.articles || [])).catch(() => setArticles([]));
  }, []);

  return (
    <>
      <Helmet>
        <title>Insights | Carter Asset Management</title>
        <meta name="description" content="Explore Carter Asset Management insights and educational articles." />
      </Helmet>
      <main className="section-container py-10 md:py-20">
        <header className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-wide text-sky-700/70">Insights</p>
          <h1 className="mt-2 text-2xl md:text-4xl font-semibold tracking-tight text-cam-blue">Latest insights and informational articles.</h1>
        </header>

        <section className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <Link key={article.slug} to={`/insights/${article.slug}`} className="block overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-glow hover:ring-cam-blue/30">
              {article.featuredImage ? <img src={article.featuredImage} alt="" className="h-44 w-full object-cover" /> : null}
              <div className="p-5">
                <h2 className="text-lg font-semibold text-slate-900">{article.title}</h2>
                {article.excerpt ? <p className="mt-2 text-sm text-slate-600">{article.excerpt}</p> : null}
                <p className="mt-3 text-xs text-slate-500">
                  {article.publishDate ? new Date(article.publishDate).toLocaleDateString() : 'No date'}
                  {article.author ? ` • ${article.author}` : ''}
                </p>
              </div>
            </Link>
          ))}
          {!articles.length ? <p className="text-slate-600">No published articles yet.</p> : null}
        </section>
      </main>
    </>
  );
}
